import { useCallback, useEffect, useRef, useState } from 'react'

import ReactLoading from 'react-loading'

import { useParams } from 'react-router-dom'

import { toast } from 'react-toastify'

import { Form as FormPacks } from '@unform/web'

import * as Yup from 'yup'

import Button from '../../../components/Buttons/Button'

import { Input, Radio, Select } from '../../../components/Form'

import { Header } from '../../../components/Main'

import history from '../../../routes/history'

import api from '../../../services/api'

import { Container, InputGroup, LabelInput } from './styles'

function Form(props) {
  const [loading, setLoading] = useState(false)
  const [produtos, setProdutos] = useState([])
  const [modulo, setModulo] = useState({})
  const formRef = useRef(null)
  const { id } = useParams()

  const { type, formTitle } = props

  const getModulo = useCallback(async () => {
    const response = await api.get(`/modulos/${id}`)
    if (response.data) {
      formRef.current.setData(response.data)
      formRef.current.setFieldValue('pago', String(response.data.pago))
      setModulo(response.data)
    }
  }, [id])

  const getProducts = useCallback(async () => {
    const response = await api.get('/produtos-list')

    setProdutos(response.data)
  }, [])

  const getSelectedOption = useCallback(() => {
    const option = produtos?.find(produto => produto.id === modulo.produto_id)

    if (option) {
      formRef.current.setFieldValue('produto_id', {
        value: option.id,
        label: option.titulo
      })
    }
  }, [produtos, modulo])

  useEffect(() => {
    getProducts()
    if (type === 'edit') {
      getModulo()
    }
  }, [type, getModulo, getProducts])

  useEffect(() => {
    if (type === 'edit') {
      getSelectedOption()
    }
  }, [type, getSelectedOption])

  const customStyles = {
    control: base => ({
      ...base,
      height: '100%',
      maxHeight: 50,
      background: 'var(--black)',
      borderColor: 'transparent',
      borderRadius: 5,
      boxShadow: 'none',
      '&:hover': {
        borderColor: 'none'
      }
    }),
    valueContainer: base => ({
      ...base,
      height: '100%',
      maxHeight: 50,
      color: 'var(--primary)'
    }),
    placeholder: base => ({
      ...base,
      color: 'var(--primary)'
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? 'var(--black)' : 'var(--black)',
      color: 'var(--primary)'
    }),
    singleValue: base => ({
      ...base,
      color: 'var(--primary)'
    }),
    menuList: base => ({
      ...base,
      backgroundColor: 'var(--black)',
      opacity: '0.5'
    })
  }

  async function handleSubmit(data) {
    setLoading(true)
    try {
      const schema = Yup.object().shape({
        nome: Yup.string().required('Nome obrigatório'),
        preco: Yup.string().required('Preço obrigatório'),
        pago: Yup.string().nullable().required('Opção obrigatório'),
        produto_id: Yup.string().nullable().required('Opção obrigatório')
      })

      await schema.validate(data, {
        abortEarly: false
      })

      formRef.current.setErrors({})

      const { nome, preco, produto_id, pago } = data

      if (type === 'edit') {
        const response = await api.put(`modulos/${id}`, {
          nome,
          preco,
          produto_id,
          pago
        })

        if (response.data) {
          setLoading(false)
          toast.success('Dados actualizados com sucesso!', {
            position: toast.POSITION.TOP_RIGHT
          })
        }
      } else {
        await api.post('/modulos', { nome, preco, pago, produto_id })

        setLoading(false)

        toast.success('Registo criado com sucesso!', {
          position: toast.POSITION.TOP_RIGHT
        })

        history.goBack()
      }
    } catch (err) {
      if (err.response) {
        setLoading(false)
        toast.error('Ocorreu um erro, tente novamente!', {
          position: toast.POSITION.TOP_RIGHT
        })
      }

      if (err instanceof Yup.ValidationError) {
        const validationErrors = {}
        if (err instanceof Yup.ValidationError) {
          err.inner.forEach(error => {
            validationErrors[error.path] = error.message
          })
          formRef.current.setErrors(validationErrors)
          setLoading(false)
        }
      }
    }
  }

  return (
    <>
      <Header title={formTitle} options="false" />
      <Container>
        <FormPacks ref={formRef} onSubmit={handleSubmit}>
          <InputGroup>
            <LabelInput>Nome</LabelInput>
            <Input type="text" name="nome" />
          </InputGroup>
          <InputGroup>
            <LabelInput>Preço</LabelInput>
            <Input type="text" name="preco" />
          </InputGroup>

          <InputGroup>
            <LabelInput>Produto</LabelInput>
            <Select
              name="produto_id"
              options={produtos.map(produto => {
                return { value: produto.id, label: produto.titulo }
              })}
              placeholder="Selecione o produto"
              styles={customStyles}
            />
          </InputGroup>

          <LabelInput>Pago</LabelInput>
          <Radio
            name="pago"
            options={[
              { id: 1, label: 'Sim' },
              { id: 0, label: 'Não' }
            ]}
          />

          <Button
            width={100}
            height={35}
            margin=" 25px 5px 0 5px;"
            type="submit"
            title="Guardar"
            loading={
              loading && (
                <ReactLoading type="spin" color="#fff" height={20} width={20} />
              )
            }
          />
        </FormPacks>
      </Container>
    </>
  )
}

export default Form
